module.exports = __webpack_public_path__ + "static/cosi5s-f8abce30f7a3f422c21f8dced968553a.jpg";